import { Route, Routes } from 'react-router-dom';
import { ExecutionPage } from '@/features/executions/execution-page';
import React from 'react';
import { useCampaignContext } from '@/features/campaigns/campaign-context';
import { trpc } from '@/utils/trpc-client';
import { ExecutionContextProvider } from '@/features/executions/execution-context';
import { ExecutionLineItemPage } from '@/features/executions/execution-line-item-page';

export function ExecutionRoutes() {
  const { campaign } = useCampaignContext();
  const execution = trpc.getExecution.useQuery({ execution_id: campaign.proposal_id });
  const lineItems = trpc.getExecutionLineItems.useQuery({ execution_id: campaign.proposal_id });

  return (
    <ExecutionContextProvider execution={execution} lineItems={lineItems}>
      <Routes>
        <Route index element={<ExecutionPage />} />
        <Route path="lineitems/:lineItemId/*" element={<ExecutionLineItemPage />} />
      </Routes>
    </ExecutionContextProvider>
  );
}
